<script setup lang="ts">
import { computed, useSlots } from 'vue';

const props = defineProps({
  actions: {
    default: () => [],
    type: Array,
  },
  description: {
    default: '',
    type: String,
  },
  loading: {
    default: false,
    type: Boolean,
  },
  subtitle: {
    default: '',
    type: String,
  },
  title: {
    default: '',
    type: String,
  },
});

const slots = useSlots();
const hasHeader = computed(() => props.title || props.description || !!slots['header-left']);
</script>

<template>
  <div class="page-header d-print-none" v-if="hasHeader">
    <div class="container-page margin-auto">
      <div class="row g-2" :class="props.subtitle || slots['header-left'] ? 'align-items-end' : 'align-items-center'">

        <!-- title: slot personalizado ou props padrão -->
        <div class="col">
          <slot name="header-left">
            <div class="page-pretitle">{{ props.title }}</div>
            <h2 class="page-title">
              {{ props.description }}
              <div v-if="props.loading" class="spinner-border spinner-border-sm" style="margin-left: 10px;" />
            </h2>
            <p v-if="props.subtitle" class="page-subtitle">{{ props.subtitle }}</p>
          </slot>
        </div>

        <!-- actions -->
        <div class="col-auto ms-auto d-print-none">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>

  <div class="page-body" :class="{ 'page-body--no-header': !hasHeader }">
    <div class="container-page">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.container-page {
  margin: 0 16px;

  @media screen and (min-width: 1200px) {
    margin: 0 32px;
  }
}

.page-body--no-header {
  padding-top: 0 !important;
}

.page-subtitle {
  font-size: 13px;
  color: #6B7280;
  margin-top: 4px;
  margin-bottom: 0;
  max-width: 680px;
}
</style>
